import { Component, Input } from "@angular/core";
import { animate, style, transition, trigger } from "@angular/animations";

@Component({
  selector: "app-shimmer-loader",
  templateUrl: "./shimmer-loader.component.html",
  styleUrls: ["./shimmer-loader.component.scss"],
  animations: [
    trigger("shimmerAnimation", [
      transition("void => *", [
        style({ backgroundPosition: "-100% 0" }),
        animate("2s", style({ backgroundPosition: "100% 0" })),
      ]),
    ]),
  ],
  standalone: false,
})
export class ShimmerLoaderComponent {
  @Input() shimmerFor: string = "";
  @Input() width: string = "100%";
  @Input() height: string = "100%";
  @Input() borderRadius: string = "5px";
  @Input() animationDirection: "left" | "right" = "left";

  constructor() {}
}
